
<template>
  <div>
    <v-navigation-drawer
      
      class="fixedSidebar hidden-sm-and-down"
      id="fixed"
      style=""
      float
      width="14%"
      
      permanent
      wrap
      justify-center
      fill-height
    >
      <!-- <v-layout wrap justify-center text-center>
         <v-flex xs12 py-10>
           <router-link
          active-class="RB"
            style="text-decoration: none; color: black ;"
            :to="{ name: 'editSellerprofile' }"
          > 
            PROFILE 
            </router-link>
             </v-flex>
        <v-flex xs12 >
          <router-link
          active-class="RB"
            style="text-decoration: none; color: black ;"
                       :to="userData.status == 'Active' && userData.isProfileCompleted ? { name: 'productSold' } : { name: 'editSellerprofile' } "

          >
           PRODUCTS SOLD
          </router-link>
        </v-flex>
        <v-flex xs12 pt-8>
          <router-link
          active-class="RB"
            style="text-decoration: none; color: black;"
            :to="userData.status == 'Active' && userData.isProfileCompleted ? { name: 'addProduct' } : { name: 'editSellerprofile' } "
          >
            ADD A PRODUCT
          </router-link>
        </v-flex>
        <v-flex xs12 pt-8>
          <router-link
            style="text-decoration: none; color: black;"
             :to="userData.status == 'Active' && userData.isProfileCompleted ? { name: 'analytics' } : { name: 'editSellerprofile' } "
             active-class="RB"
          >
            ANALYTICS
          </router-link>
        </v-flex>
        <v-flex xs12 pt-8>
           <router-link
            style="text-decoration: none; color: black;"
             :to="userData.status == 'Active' && userData.isProfileCompleted ? { name: 'stock' } : { name: 'editSellerprofile' } "
             active-class="RB"
          > STOCK
           </router-link>
            </v-flex>
           
       
       
      </v-layout> -->
      <v-layout wrap justify-center text-center style="border-top: 1px solid #D5D5D5">
        <v-flex py-5 xs12 v-for="(item,i) in pages" :key="i">
           <router-link
            style="text-decoration: none; color: black;"
             :to="userData.status == 'Active' && userData.isProfileCompleted ?  item.route : { name: 'editSellerprofile' } "
             active-class="RB"
          > {{item.page}}
           </router-link>

        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <v-layout wrap px-3 px-md-0>
      <!-- <v-flex xs2 class= "hidden-sm-and-down" >
      </v-flex> -->
      <v-flex xs12>
        <v-tabs show-arrows class="hidden-md-and-up">
          <v-tab v-for="(item, i) in items" :key="i">
            
           <router-link
            style="text-decoration: none; color: black;"
            :to='item.link '  
             active-class="RB"
          >

            <span>{{ item.name }} </span>
           </router-link>

          </v-tab>
        </v-tabs>
      </v-flex>
      <v-flex xs12 md12  :style="
                    $vuetify.breakpoint.name =='lg' || $vuetify.breakpoint.name =='md' || $vuetify.breakpoint.name =='xl' ? {
                          'border-left': '1px solid #D5D5D5',
                           'border-top': '1px solid #D5D5D5',
                        }
                      : {
                          'border-left':'0px  !important',
                        }
                  "  >
        <router-view />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
         {
          name: "PROFILE",
          link: "/editSellerprofile"

        },
          {
          name:" EDIT PROFILE",
          link: "/editSellerprofile"
        },
       
       
        {
          name:"ANALYTICS",
          link:"/analytics"

        },
         {
          name:"ADD PRODUCTS",
          link: "/addProduct"
        },

         {
          name:"PRODUCT SOLD",
          link: "/productSold"

        },
        {
          name:"STOCK",
          link:"/stock"

        },
      
       
        
      ],
      pages:[
         {
          page:"PROFILE",
          route: "/sellerProfile"
        },
        {
          page:" EDIT PROFILE",
          route: "/editSellerprofile"
        },
        {
          page:"ANALYTICS",
          route: "/analytics"
        },
        {
          page:"ADD PRODUCTS",
          route: "/addProduct"
        },
        {
          page:"STOCK",
          route: "/stock"
        },
        {
          page:"PRODUCT SOLD",
          route: "/productSold"
        },
        // {
        //   page:" PREVIOUS ORDER",
        //   route: "/previousOrder"
        // },
      ]
    };
  },
  computed:{
    userData()
    {
      return this.$store.state.userData;
    }
  },
};
</script>

<style scoped>
.fixedSidebar {
  position: -webkit-sticky;
  position: sticky;
  top: 50;
  left: 0;
  overflow-y: hidden;
  float: left;
  z-index: 2;
  -webkit-overflow-scrolling: touch;
  transition: 2s;
  display: block;
  height: 100vh;
}
</style>